export enum OrderAddressType {
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY',
  INVOICE = 'INVOICE',
}
